

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

import certUtils from '../../../global/utils/certUtils';
import filterUtils from '../../../global/utils/filterUtils';

const RequiredTrainingStatus = ({
  moduleCertificates
  , contentModule
}) => {
  /**
   * NOTE: latestCert is not enough on its own. Causes issues if a user has a valid cert but the most recently updated cert is invalid.
   */
  const completedCert = certUtils.findCompletedCert(moduleCertificates);
  const latestCert = certUtils.getLatestCert(moduleCertificates);
  const hasValidCert = !!completedCert // findCompletedCert() already checks for validity. So if completedCert is defined, it's valid.
  
  // if(contentModule && contentModule._id) {
  //   console.log("testing", moduleCertificates)
  //   console.log("completedCert", completedCert)
  //   console.log("latestCert", latestCert)
  //   console.log("hasValidCert", hasValidCert)
  // }

  if(!contentModule) {
    return null
  } else if(!latestCert) {
    return (
      <tr>
        <td>
          {contentModule.title}
        </td>
        <td>
          Incomplete
        </td>
      </tr>
    )
  } else {
    return (
      <tr>
        <td>
          {contentModule.title}
        </td>
        <td>
          {hasValidCert ? _.startCase(completedCert.status) : latestCert.status === 'completed' ? 'Expired' : _.startCase(latestCert.status)}
        </td>
      </tr>
    )
  }
}

RequiredTrainingStatus.propTypes = {
  moduleCertificates: PropTypes.array
  , contentModule: PropTypes.object
}

RequiredTrainingStatus.defaultProps = {
  moduleCertificates: []
  , contentModule: null
}

export default RequiredTrainingStatus;



// WEBPACK FOOTER //
// modules/contentModule/components/RequiredTrainingStatus.js.jsx